import { render, staticRenderFns } from "./UserOverview.vue?vue&type=template&id=8668069c&scoped=true&"
import script from "./UserOverview.vue?vue&type=script&lang=js&"
export * from "./UserOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserOverview.vue?vue&type=style&index=0&id=8668069c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8668069c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VDataTable,VDivider,VIcon,VSelect,VSpacer,VSwitch})
